import useStudentResource from "./useStudentResource";
import handleSignatureSubmit from "./handleSignatureSubmit";

export default function useSignatureLogic(id){


    const studentResource = useStudentResource({id})
    const {
        form,
        updateForm,
        sessionOptions,
        selectedDateData,
        handleSubmit,
        loadSignatures
    } = handleSignatureSubmit({
        id,         
        studentData: studentResource?.studentData,
        fetchStudentData: studentResource?.fetchStudentData
    });

    return {
        ...studentResource,
        handleSubmit,
        loadSignatures,
        form,
        updateForm,
        sessionOptions,
        selectedDateData,
    } 
}